import { all, call, put, takeLatest } from '@redux-saga/core/effects';
import axios from 'axios';

import {
  requestCreateReaction,
  requestViewReactions,
  requestDeleteReaction,
  requestSwitchReaction
} from './reaction.actions';
import { getCreateReactionRequest, getViewReactionsRequest, getDeleteReactionRequest } from './reaction.endpoints';

import { addSystemNotice } from '../../slices/system/system.slice';
import { setReactions, switchReaction } from '../../slices/programme/tribe/tribe.slice';

import { ERROR } from '../../utils/constants';
import { getErrorMessage } from '../../utils/api-util';

export function* performCreateReactionRequest({ payload }) {
  const { input, onSuccess, onError } = payload;

  try {
    const [endpoint, options] = getCreateReactionRequest(input);

    yield call(axios, endpoint, options);

    if (onSuccess) {
      yield call(onSuccess);
    }
  } catch (error) {
    const message = getErrorMessage(error);
    yield put(addSystemNotice({ type: ERROR, message }));

    if (onError) {
      yield call(onError);
    }
  }
}

export function* watchForCreateReactionRequest() {
  yield takeLatest(requestCreateReaction.type, performCreateReactionRequest);
}

export function* performViewReactionsRequest({ payload }) {
  const { memberExternalReference, onSuccess } = payload;

  try {
    const [endpoint, options] = getViewReactionsRequest(memberExternalReference);

    const { data } = yield call(axios, endpoint, options);

    if (onSuccess) {
      yield call(onSuccess);
    }

    yield put(setReactions(data.reactions));
  } catch (error) {
    const message = getErrorMessage(error);
    yield put(addSystemNotice({ type: ERROR, message }));
  }
}

export function* watchForViewReactionsRequest() {
  yield takeLatest(requestViewReactions.type, performViewReactionsRequest);
}

export function* performDeleteReactionRequest({ payload }) {
  const { reaction, memberExternalReference, postExternalReference, onSuccess, onError } = payload;

  try {
    const [endpoint, options] = getDeleteReactionRequest(reaction, memberExternalReference, postExternalReference);

    yield call(axios, endpoint, options);

    if (onSuccess) {
      yield call(onSuccess);
    }
  } catch (error) {
    const message = getErrorMessage(error);
    yield put(addSystemNotice({ type: ERROR, message }));

    if (onError) {
      yield call(onError);
    }
  }
}

export function* watchForDeleteReactionRequest() {
  yield takeLatest(requestDeleteReaction.type, performDeleteReactionRequest);
}

export function* performSwitchReactionRequest({ payload }) {
  const { postExternalReference, oldReaction, newReaction, programmeExternalReference, memberExternalReference } =
    payload;

  yield put(switchReaction({ postExternalReference, oldReaction, newReaction }));

  try {
    let request = getDeleteReactionRequest(oldReaction, memberExternalReference, postExternalReference);

    yield call(axios, ...request);

    request = getCreateReactionRequest({
      reaction: newReaction,
      postExternalReference,
      programmeExternalReference
    });

    yield call(axios, ...request);
  } catch (error) {
    yield put(
      switchReaction({
        postExternalReference,
        oldReaction: newReaction,
        newReaction: oldReaction
      })
    );

    const message = getErrorMessage(error);
    yield put(addSystemNotice({ type: ERROR, message }));
  }
}

export function* watchForSwitchReactionRequest() {
  yield takeLatest(requestSwitchReaction.type, performSwitchReactionRequest);
}

export default function* reactionSaga() {
  yield all([
    watchForCreateReactionRequest(),
    watchForViewReactionsRequest(),
    watchForDeleteReactionRequest(),
    watchForSwitchReactionRequest()
  ]);
}
